import React, { Fragment, useEffect, useState, useRef } from 'react';
import { Button, Spinner } from "reactstrap";
import { SignContractButton } from './SignContractButton';
import { ContractDepositButton } from './ContractDepositButton';
import { ContractComplete } from './ContractComplete';
import { ConfirmWorkCompletion } from './ConfirmWorkCompletion';
import { ContractState } from '../../../contract/Data';
import useContract from '../../../hooks/useContract';
import FormToast from '../../Form/Toast';
import PercentageNegotiation from './PercentageNegotiation';
import PartiesDisagree from './PartiesDisagree';
import { SetPercentageJobPayable } from './SetPercentageJobPayable';
import { APPConstants } from '../../../constants/app';
import ClockCountDown from '../assets/clock_count_down.svg';

export function SignContract(solution, init) {
    const contractAddress = solution.contractAddress;
    const contractBc = useContract(contractAddress);
    
    const [blockChainContractExecutingError, setBlockChainContractExecutingError] = useState(null);
    const blockChainContractLoadedRef = useRef(false);
    const initRef = useRef(true);

    const isContractor = solution.userType === 'contractor';
    const isHomeowner = !isContractor;

    useEffect(() => {
        if (!blockChainContractLoadedRef.current && contractAddress && !contractBc.loading) {
            blockChainContractLoadedRef.current = true;
            contractBc.get();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contractBc]);

    useEffect(() => {
        if (initRef.current) {
            if (!contractAddress) {
                window.location.reload();
            }
            initRef.current = false;
            return;
        }
        setBlockChainContractExecutingError(null);
        blockChainContractLoadedRef.current = false;

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [init]);

    const handleContractReload = (e) => {
        contractBc.get();
        e.preventDefault();
        return false;
    }

    const ErrorToast = () => {
        return blockChainContractExecutingError && blockChainContractExecutingError.reason ? (
            <div className='col-sm-12'>
                <FormToast show={true} message={blockChainContractExecutingError.reason} className="bg-danger" />
            </div>
        ) : (
            ''
        )
    }

    return (
        <Fragment>
            <div className='row mt-3 w-100'>
                {
                    contractBc?.loading ? (
                        <div className='col-sm-12'>
                            Loading blockchain data...
                            <Spinner className="ms-1" size="sm" />
                        </div>
                    ) : (
                        !contractBc?.contract || contractBc.error ? (
                            <div className='col-sm-12'>
                                <FormToast
                                    show={true}
                                    message={
                                        <span>
                                            Error loading contract data.
                                            <a
                                                href={APPConstants.APP_BASE_URI}
                                                className='text-light ms-3'
                                                onClick={handleContractReload}
                                            >
                                                Try again
                                            </a>
                                        </span>
                                    }
                                    className="bg-danger"
                                />
                            </div>
                        ) : (
                            <Fragment>
                                {
                                    !contractBc?.contract?.isHomeownerIn && isHomeowner ? (
                                        <SignContractButton
                                            contractBc={contractBc}
                                            userType="homeowner"
                                            key="homeowner"
                                            onAction={
                                                () => { setBlockChainContractExecutingError(null) }
                                            }
                                            onSuccess={
                                                () => { contractBc.get() }
                                            }
                                            onError={
                                                (data) => { setBlockChainContractExecutingError(data) }
                                            }
                                        />
                                    ) : (
                                        <Fragment>                          
                                            {
                                                !contractBc?.contract?.isContractorIn && isContractor ? (
                                                    <Fragment>
                                                        <SignContractButton
                                                            contractBc={contractBc}
                                                            userType="contractor"
                                                            key="contractor"
                                                            onAction={
                                                                () => { setBlockChainContractExecutingError(null) }
                                                            }
                                                            onSuccess={() => { contractBc.get() }}
                                                            onError={(data) => { setBlockChainContractExecutingError(data) }}
                                                        />
                                                    </Fragment>
                                                ) : (
                                                    <Fragment>
                                                        {
                                                            isHomeowner && !contractBc?.contract?.isContractorIn &&
                                                            <Button color='dark' className='rounded-3' size='lg' active={false} disabled={true}>
                                                                <img className='mt-1 me-2'
                                                                    style={{verticalAlign: 'sub'}}
                                                                    alt=''
                                                                    src={ClockCountDown}
                                                                ></img>
                                                                Waiting for the contractor to sign
                                                            </Button>
                                                        }
                                                        {
                                                            isContractor && !contractBc?.contract?.isHomeownerIn &&
                                                            <Button color='dark' className='rounded-3' size='lg' active={false} disabled={true}>
                                                                <img className='mt-1 me-2'
                                                                    style={{verticalAlign: 'sub'}}
                                                                    alt=''
                                                                    src={ClockCountDown}
                                                                ></img>
                                                                Waiting for the homeowner to sign
                                                            </Button>
                                                        }
                                                        {
                                                            contractBc.contract?.currState === ContractState.AWAITING_PAYMENT && (
                                                                isHomeowner ? (
                                                                <ContractDepositButton
                                                                    contractBc={contractBc}
                                                                    onSuccess={() => { setBlockChainContractExecutingError(null); contractBc.get() }}
                                                                    onError={(data) => { setBlockChainContractExecutingError(data) }}
                                                                />
                                                                ) : (
                                                                    isContractor && (
                                                                                            <Button color='dark' className='rounded-3' size='lg' active={false} disabled={true}>
                                                                                                <img className='mt-1 me-2'
                                                                                                    style={{ verticalAlign: 'sub' }}
                                                                                                    alt=''
                                                                                                    src={ClockCountDown}
                                                                                                ></img>
                                                                                                Waiting for the homeowner deposit
                                                                                            </Button>
                                                                    )
                                                                )
                                                            )
                                                        }
                                                        {
                                                            contractBc.contract?.currState === ContractState.AWAITING_WORKCOMPLETION && (
                                                                isHomeowner ? (
                                                                    <Fragment>
                                                                        <ConfirmWorkCompletion
                                                                            contractBc={contractBc}
                                                                            onSuccess={() => {
                                                                                setBlockChainContractExecutingError(null);
                                                                                contractBc.get();
                                                                                solution.onSolutionUpdate(true);
                                                                            }}
                                                                            onError={(data) => { setBlockChainContractExecutingError(data) }}
                                                                            solution={solution?.solution}
                                                                        />
                                                                    </Fragment>
                                                                ) : (
                                                                    isContractor ? (
                                                                        (!contractBc.contract?.ctInAgreement && contractBc.contract?.amountToHomeowner === 0) ? (
                                                                            <p className='d-inline'>
                                                                                <span className={'text-success'}>● </span>
                                                                                    The homeowner made the initial deposit of 
                                                                                    <span className={'text-success'}> { contractBc.contract?.balance } ETH </span>
                                                                                    to the contract.
                                                                                    <br/>
                                                                                    You may now start working.
                                                                                    <br/>
                                                                                    When the Homeowner confirms the work is complete,
                                                                                    <span className={'text-success'}> { contractBc.contract?.amountToContractor } ETH </span>
                                                                                    will be transferred to your wallet.
                                                                            </p>
                                                                        ) : (
                                                                            <p className='d-inline'>
                                                                                <span className={'text-success'}>● </span>
                                                                                    Awaiting for Homeowner to confirm work completion to transfer
                                                                                    <span className={'text-success'}> { contractBc.contract?.amountToContractor } ETH </span>
                                                                                    to your wallet.
                                                                            </p>
                                                                        )
                                                                    ) : (
                                                                        ''
                                                                    )
                                                                )
                                                            )
                                                        }
                                                        {
                                                            contractBc.contract?.currState === ContractState.COMPLETE &&
                                                            <ContractComplete userType={solution.userType} contractBc={contractBc} />
                                                        }
                                                    </Fragment>
                                                )
                                            }
                                        </Fragment>
                                    )
                                }
                                <ErrorToast/>
                            </Fragment>
                        )
                    )
                }
            </div>
        </Fragment>
    )
}